module.exports = __webpack_public_path__ + "static/media/CORPORATE OFFSITES.fe261c50.png";